import * as Common from '@/tenant/common';

export class DirectAccessQuery extends Common.Query {
  constructor(source: DirectAccessTargetFlags,sourceNo:string, isItem:boolean = false) {
    super("DirectAccessQuery", new Common.ModelBinder(DirectAccessQueryResult));
    this.sourceNo = sourceNo;
    this.source = source;
    this.isItem = isItem; //商品明細からの呼出し
  }
  public sourceNo : string;
  public source : DirectAccessTargetFlags;
  public isItem : boolean;
}


export class DirectAccessQueryResult extends Common.ObjectBase {
  constructor() {
    super('DirectAccessQueryResult');
    this.binders.salesOrders = new Common.ModelBinder(VoucherNo,true);
    this.binders.salesOrderPayments  = new Common.ModelBinder(VoucherNo,true);
    this.binders.salesDeliveries = new Common.ModelBinder(VoucherNo,true);
    this.binders.salesInvoices = new Common.ModelBinder(VoucherNo,true);
    this.binders.salesPayments  = new Common.ModelBinder(VoucherNo,true);
    this.binders.purchaseOrders  = new Common.ModelBinder(VoucherNo,true);
    this.binders.purchaseOrderPayments  = new Common.ModelBinder(VoucherNo,true);         
    this.binders.purchaseDeliveries  = new Common.ModelBinder(VoucherNo,true);
    this.binders.purchaseInvoices  = new Common.ModelBinder(VoucherNo,true);
    this.binders.purchasePayments  = new Common.ModelBinder(VoucherNo,true);
  }    
    //表示対象を指定
    public source : DirectAccessTargetFlags;       
    public target : DirectAccessTargetFlags;   
    public salesOrders : VoucherNo[];
    public salesOrderPayments : VoucherNo[];       
    public salesDeliveries : VoucherNo[];
    public salesInvoices : VoucherNo[];
    public salesPayments : VoucherNo[];      
    public purchaseOrders : VoucherNo[];
    public purchaseOrderPayments : VoucherNo[];              
    public purchaseDeliveries : VoucherNo[];
    public purchaseInvoices : VoucherNo[];
    public purchasePayments : VoucherNo[];    
}

export enum DirectAccessTargetFlags
{
    SalesOrder = 1,        
    SalesOrderPayment = 2,
    SalesDelivery = 4,
    SalesInvoice = 8,
    SalesPayment = 16,
    PurchaseOrder = 32,
    PurchaseOrderPayment = 64,        
    PurchaseDelivery = 128,
    PurchaseInvoice = 256,
    PurchasePayment  =512,
    SalesCharge = 1024,
    PurchaseCharge = 2048,
}

export class VoucherNo extends Common.ObjectBase {
  constructor() {
    super('VoucherNo');
  }
    public state : number;
    public voucherNo : string;
    public voucherAmount : number;
    public voucherDate : Date;
    public voucherCurrency : string;
    public completed : boolean;
    public isSource :boolean = false;
}